/// <amd-module name="Wiki/UnpublishDialog/UnpublishWikiDialog" />
import * as React from "react";

import * as Utils_String from "VSS/Core/Util/String";
import { onClickFPS } from "VSS/Platform/FPS";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { Dialog } from "VSSUI/Dialog";
import { FormItem } from "VSSUI/FormItem";
import { Spinner } from "VSSUI/Spinner";

import { WikiV2 } from "Wiki/Clients/Wiki/Contracts/Wiki";
import { getWikiClient } from "Wiki/Clients/Wiki/RestClient/Wiki";
import * as Resources from "Wiki/UnpublishDialog/Resources";
import { TelemetryConstants } from "Wiki/ViewCommon/CustomerIntelligenceConstants";
import { getWikiHomePageUrl, publish } from "Wiki/ViewCommon/Utils/WikiHelper";

export interface UnpublishWikiDialogProps {
    wiki: WikiV2;
    onDismiss: () => void;
    repositoryName: string;
}

export interface UnpublishWikiState {
    isUnpublishInprogress?: boolean;
    errorMessage?: string;
}

export class UnpublishWikiDialog extends VssComponent<UnpublishWikiDialogProps, UnpublishWikiState> {
    constructor(props: UnpublishWikiDialogProps, context: IVssComponentContext) {
        super(props, context);
        this.state = {};
    }

    public render(): JSX.Element {
        const { wiki, onDismiss } = this.props;
        const { isUnpublishInprogress, errorMessage } = this.state;
        const unPublishButtonClassName = "un-publish-button";
        // TODO: announce the disclaimer
        return (
            <Dialog
                className={"unpublish-wiki-dialog"}
                onDismiss={onDismiss}
                titleProps={{ text: Utils_String.format(Resources.UnpublishWikiTitleText, wiki.name) }}
                footerButtonProps={
                    !isUnpublishInprogress
                        ? [
                              { text: Resources.UnpublishWikiCancelButtonText, onClick: onDismiss },
                              {
                                  text: Resources.UnpublishWikiButtonText,
                                  disabled: isUnpublishInprogress,
                                  onClick: this._onUnpublishClick,
                                  danger: true,
                                  className: unPublishButtonClassName
                              }
                          ]
                        : []
                }
                defaultActiveElement={"." + unPublishButtonClassName}
            >
                <span className={"content-container"}>
                    {Resources.UnpublishWikiDisclaimerText}
                    <p />
                    <FieldRow name={Resources.WikiNameLabelText} value={this.props.wiki.name} />
                    <FieldRow name={Resources.ResposiorynameLabelText} value={this.props.repositoryName} />
                    <FieldRow name={Resources.FolderNameLabelText} value={this.props.wiki.mappedPath} />
                    {errorMessage && <FormItem message={errorMessage} error={true} />}
                    {isUnpublishInprogress ? <Spinner label={Resources.UnpublishWikiDialogSpinnerText} /> : null}
                </span>
            </Dialog>
        );
    }

    // it's made public for UT
    public _onUnpublishClick = (): void => {
        this.setState({
            isUnpublishInprogress: true,
            errorMessage: undefined
        });

        this.trackPromise(getWikiClient(this.context.pageContext).deleteWiki(this.props.wiki.id)).promise.then(
            (deletedWiki: WikiV2) => {
                publish(this.context.pageContext, TelemetryConstants.WikiUnpublished, this.props.wiki.type);
                this.props.onDismiss();
                onClickFPS(this.context.pageContext, getWikiHomePageUrl(this.context.pageContext, this.props.wiki.projectId), true);
            },
            (error: Error) => {
                this.setState({
                    errorMessage: error.message,
                    isUnpublishInprogress: false
                });
            }
        );
    };
}

interface FieldRowProps {
    name: string;
    value: string;
}

const FieldRow = (props: FieldRowProps): JSX.Element => (
    <div className="field-row">
        <label className="field-name">{props.name}</label>
        <label className="field-value">{props.value}</label>
    </div>
);

VssComponent.register("Wiki.UnpublishWikiDialog", UnpublishWikiDialog);
